const a4WidthMm = 210;
const a4HeightMm = 297;
const aspectRatio = a4HeightMm / a4WidthMm;

export const calculateA4Height = (width: number): number => {
  return Math.round(width * aspectRatio);
};

export const calculateA4HeightAndAspectRatio = ({
  height,
  width,
  newWidth
}: {
  height?: number;
  width?: number;
  newWidth: number;
}): number => {
  const calculatedAspectRatio = height && width && height > 0 && width > 0 ? height / width : aspectRatio;
  return Math.round(newWidth * calculatedAspectRatio);
};
